import { FunctionComponent } from 'react'
import styles from './Footer.module.sass'

export const Footer: FunctionComponent = () => {
	return <div className={styles.wrapper}></div>
}
